import React from "react";

interface Props {
  progress: number;
  message: string;
}

export const PersonalizationGeneratingContent = ({
  progress,
  message,
}: Props) => (
  <>
    <h2 id="pzLoadTitle">Creating amazing content for you</h2>
    <p className="pz-quip" aria-live="polite">
      {message}
    </p>
    <div className="pz-bar-wrap">
      <div
        className="pz-bar-track"
        role="progressbar"
        aria-labelledby="pzLoadTitle"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={progress}
      >
        <div className="pz-bar-fill" style={{ width: `${progress}%` }} />
      </div>
      <span className="pz-pct">{progress}%</span>
    </div>
  </>
);
